<template>
  <div class="customer_manage">
    <div class="headerk">
      <el-form :inline="true" class="rform" ref="loginform" :label-position='labelPosition'>
        <el-form-item label="客户姓名" prop="pass" class="item">
          <el-input type="text" v-model="policyerName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="pass" class="item">
          <el-input type="text" v-model="policyerMobile" class="code" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- <el-form-item label="创建时间" prop="pass" class="items">
                    <el-date-picker
                    v-model="data"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item> -->
        <el-button class="items cxbtn" @click="query">查询</el-button>
      </el-form>
    </div>
    <div class="omcontent">
      <el-table class="omtable" ref="singleTable" border :stripe='true' :data="tableData" style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column property="policyerName" label="客户姓名"></el-table-column>
        <el-table-column property="policyerMobile2" label="手机号"></el-table-column>
        <el-table-column property="totalPolicyNum" label="保单数"></el-table-column>
        <el-table-column property="totalFee" label="总保费"></el-table-column>
        <el-table-column label="操作" key="act" v-if="checkAuth('orderExport')">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type='primary' size='small' @click="goorder_manage(scope.row)">查看保单明细</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="page" background layout="total,prev, pager, next" :page-size='10' @current-change="handleCurrentChange" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
//当前实例组件

import {common} from "@/api/mixins";
export default {
  mixins: [common],
  data: () => ({
    data: '',
    policyerName: null,
    policyerMobile: null,
    select: '',
    labelPosition: 'right',
    tableData: [],
    startTime: null,
    endTime: null,
    total: 0,
  }),
  components: {},
  created() {
    this.policyer()
  },
  methods: {
    goorder_manage: function(scope) {
      this.$router.push({
        path: '/customer_details',
        query: {
          policyerName: scope.policyerName,
          phone1: scope.policyerMobile1,
          phone2: scope.policyerMobile2,
          totalFee: scope.totalFee,
          totalPolicyNum: scope.totalPolicyNum,
          policyerName: scope.policyerName,
        },
      })
    },
    //主体标分页
    handleCurrentChange: function(val) {
      this.policyer(val)
    },
    query: function() {
      if (this.data.length > 0) {
        this.startTime = this.data[0]
        this.endTime = this.data[1]
      } else {
        this.startTime = null
        this.endTime = null
      }
      this.policyer(
        1,
        this.policyerName,
        this.policyerMobile,
        this.startTime,
        this.endTime
      )
    },

    //获取主表数据
    policyer: function(num, policyerName, policyerMobile, startTime, endTime) {
      var that = this
      this.$http({
        url: '/master/content/read/policyer',
        type: 'put',
        params: {
          pageNum: num,
          policyerName: policyerName,
          policyerMobile1: policyerMobile,
          startTime: startTime,
          endTime: endTime,
        },
      }).then(function(data) {
        that.tableData = data.data
        that.total = data.total
      })
    },
  },

  mounted() {},
}
</script>
<style lang="scss">
@import '~@/sass/pages/order_manage';
</style>
